import React from 'react';
import { useRovoEntitlement } from '@atlassian/conversation-assistant-entitlement';
import { updateEnabled } from '../../../pm-plugins/rovo-agents/commands';
export var useRovoEnabled = function useRovoEnabled(_ref) {
  var editorPluginAIProvider = _ref.editorPluginAIProvider;
  var _useRovoEntitlement = useRovoEntitlement(),
    isRovoEnabled = _useRovoEntitlement.isRovoEnabled;
  return !!editorPluginAIProvider.isRovoEnabled && isRovoEnabled && typeof (editorPluginAIProvider === null || editorPluginAIProvider === void 0 ? void 0 : editorPluginAIProvider.getChannelVariables) === 'function';
};
export var useRovoEnabledForCommandPalette = function useRovoEnabledForCommandPalette(_ref2) {
  var editorPluginAIProvider = _ref2.editorPluginAIProvider;
  var isRovoEnabled = useRovoEnabled({
    editorPluginAIProvider: editorPluginAIProvider
  });
  return isRovoEnabled && !!editorPluginAIProvider.showRovoAgentsInCommandPalette;
};
/**
 * This component both:
 * - checks whether Rovo is enabled (flag + entitlement checks) before rendering its children
 * - syncs rovo plugin state with the current evaluated 'enabled' state
 */
export var RovoEnabled = function RovoEnabled(props) {
  var editorView = props.editorView,
    children = props.children;
  var enabled = useRovoEnabled({
    editorPluginAIProvider: props.editorPluginAIProvider
  });
  React.useEffect(function () {
    updateEnabled(enabled)(editorView.state, editorView.dispatch);
  }, [editorView.dispatch, editorView.state, enabled]);
  return enabled ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
};